import {Endpoints} from '../../../../../globals/api/endpoints';

export class ScaleEndpoints extends Endpoints {

  private static readonly SCALES = ScaleEndpoints.VIEWER + '/scale';
  public static readonly SCALE = ScaleEndpoints.SCALES + '/' + ScaleEndpoints.PROJECT_ID;
  public static readonly SCALE_PREVIEW = ScaleEndpoints.SCALES + '/' + ScaleEndpoints.VERSION_ID + '/preview';
}
